// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeriesToggles_panel__VDHp3 {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  margin: 8px 0;
  min-width: 0;
}

.SeriesToggles_legend__ClYQ7 {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0 4px;
}

.SeriesToggles_group__whYkD {
  border-top: 1px solid #f3f4f6;
  padding: 4px 0;
}

.SeriesToggles_group__whYkD:first-of-type {
  border-top: none;
}

.SeriesToggles_head__P\\+Q3l {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  font-size: 0.85rem;
}

.SeriesToggles_familyLabel__S0-3p {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.SeriesToggles_count__OLtHv {
  color: #6b7280;
  font-size: 0.75rem;
}

.SeriesToggles_desc__qtkaM {
  color: #6b7280;
  font-size: 0.75rem;
  margin: 4px 0;
}

.SeriesToggles_columns__AJhW0 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
}

.SeriesToggles_column__p\\+3wW {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  overflow-wrap: anywhere;
}

.SeriesToggles_swatch__lWMqB {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex: none;
}

.SeriesToggles_thresholds__8\\+P\\+5 {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/SeriesToggles.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":[".panel {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 8px 12px;\n  margin: 8px 0;\n  min-width: 0;\n}\n\n.legend {\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0 4px;\n}\n\n.group {\n  border-top: 1px solid #f3f4f6;\n  padding: 4px 0;\n}\n\n.group:first-of-type {\n  border-top: none;\n}\n\n.head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.familyLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.count {\n  color: #6b7280;\n  font-size: 0.75rem;\n}\n\n.desc {\n  color: #6b7280;\n  font-size: 0.75rem;\n  margin: 4px 0;\n}\n\n.columns {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 14px;\n}\n\n.column {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.8rem;\n  overflow-wrap: anywhere;\n}\n\n.swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex: none;\n}\n\n.thresholds {\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `SeriesToggles_panel__VDHp3`,
	"legend": `SeriesToggles_legend__ClYQ7`,
	"group": `SeriesToggles_group__whYkD`,
	"head": `SeriesToggles_head__P+Q3l`,
	"familyLabel": `SeriesToggles_familyLabel__S0-3p`,
	"count": `SeriesToggles_count__OLtHv`,
	"desc": `SeriesToggles_desc__qtkaM`,
	"columns": `SeriesToggles_columns__AJhW0`,
	"column": `SeriesToggles_column__p+3wW`,
	"swatch": `SeriesToggles_swatch__lWMqB`,
	"thresholds": `SeriesToggles_thresholds__8+P+5`
};
export default ___CSS_LOADER_EXPORT___;
